import React, { useState } from 'react';
import styles from './Details.module.scss';
import Button from 'component/atom/forms/button/Button';
import Wrapper from '../wrapper/Wrapper';
import { useNavigate } from 'react-router-dom';
import ChangePassword from './components/ChangePassword';

const UserDetails = ({ user, id }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fields = [
    { label: 'Email', value: user?.displayEmail || '-' },
    { label: 'Role', value: user?.roleName || '-' },
    { label: 'Mobile', value: user?.mobile || '-' },
    { label: 'Username', value: user?.username || '-' },
    { label: 'Phone', value: user?.phone || '-' },
    { label: 'Department', value: user?.department || '-' },
  ];

  const handleEdit = () => {
    navigate(`/edit-user/${id}`);
  };
  const handleChangPassword = (items) => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Wrapper grid>
        <div className={styles.cont}>
          {fields.map((field, index) => (
            <div key={index} className={styles.details}>
              <h3>{field.label}</h3>
              <p>{field.value}</p>
            </div>
          ))}
        </div>
        <div className={styles.buttonCont}>
          <Button label="Edit Profile" onClick={handleEdit} />
          <Button
            label="Reset Password"
            opicBackground
            onClick={handleChangPassword}
          />
        </div>
      </Wrapper>
      <ChangePassword isOpen={isModalOpen} onClose={handleClose} id={id} />
    </>
  );
};

export default UserDetails;
